import React, { useState } from 'react';
import { LANG_OPTIONS } from '../../hooks/useVoiceToText';

export const LangToggle = ({ selectedLang, setSelectedLang, teal = '#47b8a3' }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <div data-testid="lang-toggle-pill" style={{
        display: 'inline-flex', borderRadius: 20, overflow: 'hidden',
        border: `1.5px solid ${teal}30`, background: '#fff',
      }}>
        {LANG_OPTIONS.map(l => (
          <button key={l.id} type="button" data-testid={`voice-lang-${l.id.toLowerCase()}`}
            onClick={() => setSelectedLang(l.id)}
            className="tab-animate"
            style={{
              padding: '6px 14px', border: 'none', fontSize: 12, fontWeight: 700,
              cursor: 'pointer',
              background: selectedLang === l.id ? teal : 'transparent',
              color: selectedLang === l.id ? '#fff' : '#9CA3AF',
            }}>
            {l.label}
          </button>
        ))}
      </div>
      {hovered && (
        <div style={{
          position: 'absolute', bottom: '100%', left: '50%', transform: 'translateX(-50%)',
          marginBottom: 8, background: '#1F2937', color: '#fff', fontSize: 11, fontWeight: 600,
          padding: '4px 10px', borderRadius: 6, whiteSpace: 'nowrap', pointerEvents: 'none',
          animation: 'tipFadeDown 0.15s ease', zIndex: 50,
        }}>
          Language
          <div style={{
            position: 'absolute', bottom: -4, left: '50%', transform: 'translateX(-50%)',
            borderLeft: '5px solid transparent', borderRight: '5px solid transparent',
            borderTop: '5px solid #1F2937', width: 0, height: 0,
          }} />
        </div>
      )}
    </div>
  );
};

export default LangToggle;
